var map = {
	"./IDD-icon.svg": "29cc",
	"./digipo-disbursement.svg": "7f66",
	"./digipo-enquiry.svg": "c4ac",
	"./digipo-home.svg": "2ebf",
	"./digipo-quote.svg": "e830",
	"./digipo-review.svg": "c18f",
	"./digipo-transaction.svg": "3bfd",
	"./digipo-workflow.svg": "882c",
	"./digital-trade-icon.svg": "3b84",
	"./el-icon-money.svg": "e727",
	"./file-center.svg": "2181",
	"./goEarly-doc-icon.svg": "06ee",
	"./goEarly-financingRequest-icon.svg": "16c1",
	"./goEarly-icon.svg": "674c",
	"./goEarly-reconciliation-icon.svg": "d3a5",
	"./idd-bill-icon.svg": "d296",
	"./idd-calc-icon.svg": "80fd",
	"./idd-center.svg": "8071",
	"./idd-contract-icon.svg": "879b",
	"./idd-doc-icon.svg": "ac82",
	"./idd-doc.svg": "a907",
	"./idd-efiContract-icon.svg": "ed4c",
	"./idd-finace-icon.svg": "dbca",
	"./idd-gen-icon.svg": "efaa",
	"./idd-index-icon.svg": "9eab",
	"./idd-pay-icon.svg": "6a8f",
	"./idd-rise-icon.svg": "6f40",
	"./idd-sys-icon.svg": "e71d",
	"./idd-user.svg": "61ad",
	"./lls-icon-money.svg": "26c6",
	"./markPlace-assetReport-icon.svg": "a93c",
	"./markPlace-audit-icon.svg": "0805",
	"./markPlace-icon.svg": "50bf",
	"./markPlace-myAsset-icon.svg": "963e",
	"./markPlace-overview-icon.svg": "aeb6",
	"./markPlace-purchase-icon.svg": "6fd5",
	"./purchase-payment-icon.svg": "9979",
	"./scb-bind-icon.svg": "064b",
	"./scb-cash-icon.svg": "794c",
	"./scb-pay-platform-icon.svg": "6f93",
	"./switch.svg": "1ac0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "71c5";